export const UPLOAD = {
  REQUEST: 'Locations/Upload/Request',
  SUCCESS: 'Locations/Upload/Success',
  FAILURE: 'Locations/Upload/Failure'
};

export const list = {
  REQUEST: 'Locations/List/Request',
  SUCCESS: 'Locations/List/Success',
  FAILURE: 'Locations/List/Failure'
};

export const QUERY = {
  REQUEST: 'Locations/Query/Request',
  SUCCESS: 'Locations/Query/Success',
  FAILURE: 'Locations/Query/Failure'
};

export const GET = {
  REQUEST: 'Locations/Get/Request',
  SUCCESS: 'Locations/Get/Success',
  FAILURE: 'Locations/Get/Failure'
}

export const EXPORT = {
  REQUEST: 'Locations/ExportExcel/Request',
  SUCCESS: 'Locations/ExportExcel/Success',
  FAILURE: 'Locations/ExportExcel/Failure'
};;
